import AddToHomeScreen from "@mui/icons-material/AddToHomeScreen";
import MobileFriendly from "@mui/icons-material/MobileFriendly";
import MobileScreenShare from "@mui/icons-material/MobileScreenShare";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import { differenceInHours } from "date-fns";
import React from "react";
import { Maybe, OrgMembership } from "../../../../types";

export type AthleteMobileState = "inactive" | "waiting" | "expired" | "active";

interface AthleteWithMobileState {
  activationLinkSent: Maybe<string>;
  orgMembership: Maybe<Pick<OrgMembership, "id" | "isActive">>;
}

export const getAthleteMobileState = (athlete: AthleteWithMobileState): AthleteMobileState => {
  if (athlete.orgMembership?.isActive) {
    return "active";
  } else {
    if (!athlete.activationLinkSent) {
      return "inactive";
    } else {
      if (differenceInHours(new Date(), new Date(athlete.activationLinkSent)) > 72) {
        return "expired";
      } else {
        return "waiting";
      }
    }
  }
};

export const mobileStateToIcon = (state: AthleteMobileState, grey: string, green: string | undefined): React.ReactElement => {
  switch (state) {
    case "active":
      return <MobileFriendly sx={{ color: green }} />;
    case "inactive":
      return <AddToHomeScreen />;
    case "expired":
      return <PhonelinkEraseIcon color="error" />;
    case "waiting":
      return <MobileScreenShare sx={{ color: grey }} />;
    default:
      return <></>;
  }
};
